/**
 * Created by Balazs Foldesi on 2017. 12. 07.
 */
export default [
	'jQuery',
	'$compile',
	function ($, $compile) {
		return {
			restrict: 'A',
			link: function ($scope, $elem, attr) {
				// Az adott elem id attibútumának értékét behelyezi egy angularos interpolációba,
				// ami alapján megjelenik a fromban az adott kulcs alatt lévő értéke és ezt elhelyezi az elem html tartalmaként
				$elem = $($elem);
				$elem.html('{{dynaData.formData[pageID].' + attr.id + '}}');
				$compile($elem.contents())($scope);
			}
		};
	}
];
